import { render, staticRenderFns } from "./paperaddr.vue?vue&type=template&id=41568e5e&scoped=true&"
import script from "./paperaddr.vue?vue&type=script&lang=js&"
export * from "./paperaddr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41568e5e",
  null
  
)

export default component.exports